module.exports = __webpack_public_path__ + "img/5_120.9de74ec2.png";